import React from 'react';

export const CheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#FDC600" stroke="#FDC600" strokeWidth="2" />
    <path d="M16.5 8.5L11.1667 15.5L8.5 12.3182" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
